import { render, staticRenderFns } from "./salesLinkView.vue?vue&type=template&id=2e8f48ee&scoped=true&"
import script from "./salesLinkView.vue?vue&type=script&lang=js&"
export * from "./salesLinkView.vue?vue&type=script&lang=js&"
import style0 from "./salesLinkView.vue?vue&type=style&index=0&id=2e8f48ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f48ee",
  null
  
)

export default component.exports